// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSNewsList/ABSNews.less
// module id = 1133
// module chunks = 42